import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
    persist: {
        enabled: true
    },
    state: () => ({
        token: null,
        user: {
            avatar: null,
            nickName: null,
            tenantNo: null,
        },
        plants: [],
        inProject: false,
    }),
    actions: {
        setToken(token) {
            this.token = token
        },
        clearToken() {
            this.token = null
            this.user = {}
        },
        setUser(user) {
            this.user = user
        },
        setInProject(inProject) {
            this.inProject = inProject
        },
    },
});